import { defineStore } from "pinia";
import apiClient from "@/core/buildRequest";
import { useI18n } from "vue-i18n";
import { useGeneralStore } from "@/store/General.js";

export const useLeadsStore = defineStore("useLeadsStore", {
  state: () => {
    const { t } = useI18n();
    return {
      genaralStore: useGeneralStore(),
      leads: [],
      items_per_page: 100,
      current_page: 1,
      total_contacts: 0,
      total_pages: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      commentsList: "",
      headers: [
        {
          title: t("marketing_campaign_time"),
          name: "Marketing Campaign Time",
          align: "start",
          sortable: true,
          key: "campaignTime",
        },
        {
          title: t("marketing_campaign"),
          name: "Marketing Campaign",
          align: "start",
          sortable: true,
          key: "marketingCampaign",
        },
        {
          title: t("marketing_source"),
          align: "start",
          sortable: true,
          key: "platform",
        },
        {
          title: t("first_mame"),
          name: "First Name",
          align: "start",
          sortable: true,
          key: "firstName",
        },
        {
          title: t("last_name"),
          name: "Last Name",
          align: "start",
          sortable: true,
          key: "lastName",
        },
        {
          title: t("email"),
          name: "Email",
          align: "center",
          sortable: true,
          key: "email",
        },
        {
          title: t("phone_number"),
          name: "Phone Number",
          align: "start",
          sortable: true,
          key: "phoneNumber",
        },
        // {
        //   title: t("status"),
        //   name: "Status",
        //   align: "start",
        //   sortable: true,
        //   key: "status",
        // },
        {
          title: t("leads_progress"),
          name: "Leads Progress",
          align: "start",
          sortable: true,
          key: "leadsProgressCol",
        },
        // {
        //   title: t("reachability"),
        //   name: "Reachability",
        //   align: "start",
        //   sortable: true,
        //   key: "reachability",
        // },
        {
          title: t("remarks"),
          name: "Remarks",
          align: "start",
          sortable: false,
          key: "remarks",
        },
        {
          title: t("assignee"),
          name: "Assignee",
          align: "start",
          sortable: true,
          key: "assignee",
        },
        {
          title: t("Convert To Accounts"),
          name: "Convert To Accounts",
          align: "start",
          sortable: false,
          key: "conversations",
        },
        {
          title: t("actions"),
          name: "Actions",
          align: "center",
          sortable: false,
          key: "actions",
        },
      ],
      filters: [],
      search: "",
      activities: [],
      totalItems: 0,
      leadStatuses: [
        {
          title: "Untouched",
          value: "untouched",
          backgroundColor: "#fef3f2",
          color: "#d91313",
        },
        {
          title: "Touched",
          value: "touched",
          backgroundColor: "#ecfdf3",
          color: "#027a48",
        },
      ],
      leadStatus: null,
      leadSource: null,
      leadSources: [
        { title: "PR", value: "PR" },
        { title: "Knocking Door", value: "Knocking Door" },
        { title: "Referral", value: "Referral" },
        { title: "Search", value: "Search" },
        { title: "Other", value: "Other" },
      ],
      arr_agency: [],
      selectedAgency: null,

      createLeadData: {
        first_name: "",
        last_name: "",
        phone: "",
        emails: [""],
        phones: [{ id: null, phone_name: "", phone: "" }],
        note: "",
        source: null,
        agent_id: null,
        lead_genration_time: null,
        
      },

      loading: false,
      singleLeadData: [],
      callDialog: false,
      call_statuses: [
        { title: "Planned", value: "planned", disabled: true },
        { title: "Held", value: "held", disabled: false },
        { title: "Not Held", value: "not_held", disabled: false },
      ],
      data_call: {
        call_for: "",
        number: [],
        phone: "",
        status: "",
        type: "Call Summary",
        from: "",
        content: "",
      },
      meetingDialog: false,
      data_meeting: {
        meeting_for: "",
        number: [], // ← مصفوفة أرقام للـ UI (objects {phone})
        phone: "", // ← حقل فردي fallback
        content: "",
        from: "",
        to: "",
        type: "Meeting",
        status: "",
        meeting_place: "",
        meeting_title: "",
        agent_id: [],
        agent_id_filter: null,
      },

      edite_card: false,
      progress_status_list: [
        { title: "New", value: "new" },
        { title: "In Progress", value: "in_progress" },
        { title: "Recycled", value: "recycled" },
        { title: "Dead", value: "dead" },
      ],
      progress_status: "",
      edit_dialog: false,
      meeting_id: null,
      call_id: null,
      edit_call: false,
    };
  },

  getters: {
    getLeads: (state) => state.leads,
    getHeaders: (state) => state.headers,
    getActivities: (state) => state.activities,
    getTotalItems: (state) => state.totalItems,
  },

  actions: {
    async getAllLeads() {
      try {
        const response = await apiClient.get(`/leads-managment/leads`, {
          params: {
            campaign_name: this.search?.length ? this.search : null,
            filters: this.filters?.length ? this.filters : null,
            per_page: this.items_per_page,
            page: this.current_page,
            agent_id: this.agent_id_filter,
          },
        });

        const raw = response.data?.data;
        const pagination = raw.pagination;

        if (raw?.data) {
          this.leads = raw.data.map((el) => this.formatLeadData(el));
          this.totalItems = pagination.total_items || pagination.total || 0;
          this.total_pages =
            pagination.total_pages || pagination.last_page || 1;
        } else if (Array.isArray(raw)) {
          this.leads = raw.map((el) => this.formatLeadData(el));
          this.totalItems = raw.length;
          this.total_pages = 1;
        } else {
          this.leads = [];
          this.totalItems = 0;
          this.total_pages = 0;
        }
        console.log("➡️ leads length:", this.leads);
      } catch (err) {
        console.error("Error fetching leads:", err);
        this.leads = [];
        this.totalItems = 0;
        this.total_pages = 0;
      }
    },

    formatLeadData(lead) {
      return {
        id: lead.id,
        campaignTime: lead.lead_genration_time,
        marketingCampaign: lead.campaign_name,
        platform: lead.platform,
        firstName: lead.first_name,
        lastName: lead.last_name,
        phoneNumber: lead.phone,
        phones: lead.phones,
        status: lead.status,
        reachability: lead.reachablitiy,
        leadsProgressCol: "",
        comments: "",
        assignee: lead.assigned_agents,
        touchedStatus: lead.status,
        reachedStatus: lead.progress_status,
        secondReachedStatus: lead.second_progress_status,
        bookedInfo: {
          doctorName: lead.booking?.doctor_name,
          departmentName: lead.booking?.department,
          service: lead.booking?.service,
          consultationDate: lead.booking?.appointment_date,
        },
        ismanual: lead.is_manual,
        attendanceStatus: lead?.attendece_status,
        email: lead.email,
        emails: lead.emails,
        survey: [],
        activities: [],
        updates: [],
        files: [],
        trails: {
          "1st_trail": lead.call?.["1st_trail"],
          "2nd_trail": lead.call?.["2nd_trail"],
          "3rd_trail": lead.call?.["3rd_trail"],
        },
        haveTrails: !!lead?.call?.id,
        created_at: lead.created_at,
        updated_at: lead.updated_at,
        note: lead.note,
        is_converted: lead.is_converted,
        progress_status: lead.progress_status,
        new: lead.is_new,
      };
    },

    updateReachabilityStatus(id, val) {
      const index = this.leads.findIndex((item) => item.id === id);
      if (index !== -1) {
        this.leads[index].reachability = val;
      }
    },

    getAllActivities(id) {
      apiClient.get(`/leads-managment/overview/${id}`).then((res) => {
        this.activities = res.data.data;
      });
    },

    onPageChange(val) {
      this.current_page = val;
      this.getAllLeads();
    },

    onItemsPerPageChange() {
      this.current_page = 1;
      this.getAllLeads();
    },
    getAgencies() {
      apiClient
        .get(`/leads-managment/all-agents`)
        .then((res) => {
          this.arr_agency = res.data.data;
        })
        .catch((err) => {
          console.error("Error fetching agencies:", err);
        });
    },
    formatDateForMySQL(date) {
      if (!(date instanceof Date)) return null;
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`;
    },
    _cleanList(list) {
      return (Array.isArray(list) ? list : [])
        .map((v) => String(v ?? "").trim())
        .filter(Boolean);
    },

    _formatDateTimeForApi(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";

      const pad = (n) => n.toString().padStart(2, "0");
      const year = d.getFullYear();
      const month = pad(d.getMonth() + 1);
      const day = pad(d.getDate());
      const hours = pad(d.getHours());
      const minutes = pad(d.getMinutes());
      const seconds = pad(d.getSeconds());

      // ✅ الشكل اللي انت عايزه بالضبط
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    _buildCreateLeadFormData(phonesPayload, emails) {
      const fd = new FormData();

      // --- Fields العادية ---
      fd.append("first_name", this.createLeadData.first_name || "");
      fd.append("last_name", this.createLeadData.last_name || "");
      fd.append(
        "lead_genration_time",
        this._formatDateTimeForApi(this.createLeadData.lead_genration_time)
      );
      fd.append(
        "source",
        this.leadSource?.value ?? this.createLeadData.source ?? ""
      );
      fd.append(
        "agent_id",
        this.selectedAgency?.id ?? this.createLeadData.agent_id ?? ""
      );
      if (this.createLeadData.note) {
        fd.append("note", this.createLeadData.note);
      }

      // ✅ أهم جزء: شكل phones[i][...]
      phonesPayload.forEach((p, index) => {
        if (p.id != null) {
          fd.append(`phones[${index}][id]`, String(p.id));
        }
        fd.append(`phones[${index}][phone]`, p.phone);
        if (p.phone_name) {
          fd.append(`phones[${index}][phone_name]`, p.phone_name);
        }
      });

      // لو محتاج phone أساسي (أول رقم)
      if (phonesPayload[0]?.phone) {
        fd.append("phone", phonesPayload[0].phone);
      }

      // Emails
      (emails || []).forEach((em, i) => {
        fd.append(`emails[${i}]`, em); // أو emails[] لو الـ backend كده
        // fd.append("emails[]", em);
      });
      fd.append("progress_status", this.progress_status);

      return fd;
    },

    _resetCreateLeadData() {
      this.createLeadData = {
        first_name: "",
        last_name: "",
        phone: "",
        emails: [""],
        phones: [{ id: null, phone_name: "", phone: "" }],
        note: "",
        source: null,
        agent_id: null,
        lead_genration_time: null,
        progress_status: "",
      };

      this.leadSource = null;
      this.selectedAgency = null;
      this.progress_status = "";
    },

    async createLead() {
      this.loading = true;

      // --------- Phones: نبني الـ payload + validation ---------
      const phonesPayload = (this.createLeadData.phones || [])
        .map((p) => {
          const phone = (p?.phone || "").trim();
          const phone_name = (p?.phone_name || "").trim();

          if (!phone) return null; // تجاهل الصف الفاضي
          return {
            ...(p.id ? { id: p.id } : {}), // لو في id (في التعديل مثلاً)
            phone,
            phone_name,
          };
        })
        .filter(Boolean);

      const phoneNumbers = phonesPayload.map((p) => p.phone);

      // --------- Emails ---------
      const emails = this._cleanList(this.createLeadData.emails || []);

      const hasDuplicate = (arr) => new Set(arr).size !== arr.length;

      // Duplicates
      if (hasDuplicate(phoneNumbers)) {
        this.loading = false;
        this.genaralStore.showSnackbar(
          "Duplicate phone numbers are not allowed",
          "error"
        );
        return;
      }

      if (hasDuplicate(emails)) {
        this.loading = false;
        this.genaralStore.showSnackbar(
          "Duplicate emails are not allowed",
          "error"
        );
        return;
      }

      // Email format validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      for (const email of emails) {
        if (!emailRegex.test(email)) {
          this.loading = false;
          this.genaralStore.showSnackbar(
            `Invalid email format: ${email}`,
            "error"
          );
          return;
        }
      }

      // Phone format validation
      const phoneRegex = /^\+?\d{7,15}$/;
      for (const phone of phoneNumbers) {
        if (!phoneRegex.test(phone)) {
          this.loading = false;
          this.genaralStore.showSnackbar(
            `Invalid phone number: ${phone}`,
            "error"
          );
          return;
        }
      }

      // Required fields
      const required = {
        first_name: !!this.createLeadData.first_name,
        last_name: !!this.createLeadData.last_name,
        phones: phoneNumbers.length > 0,
        lead_genration_time: !!this.createLeadData.lead_genration_time,
        source: !!(this.leadSource?.value ?? this.createLeadData.source),
        agent_id: !!(this.selectedAgency?.id ?? this.createLeadData.agent_id),
      };

      const firstMissing = Object.entries(required).find(([, ok]) => !ok)?.[0];
      if (firstMissing) {
        this.loading = false;
        this.genaralStore.showSnackbar(
          `You Have To Fill: ${firstMissing.replaceAll("_", " ")}`,
          "error"
        );
        return;
      }

      try {
        const formData = this._buildCreateLeadFormData(phonesPayload, emails);

        const res = await apiClient.post(
          "/leads-managment/create-lead",
          formData
        );

        this.loading = false;
        this.dialog = false;
        await this.getAllLeads();
        this._resetCreateLeadData();
        this.genaralStore.showSnackbar(
          res.data?.msg || "Lead created",
          "#237276"
        );
      } catch (err) {
        console.error("Error creating lead:", err?.response?.data || err);
        this.loading = false;
        this.genaralStore.showSnackbar(
          err?.response?.data?.msg || "Error creating lead",
          "error"
        );
      }
    },

    getALead(id) {
      let leadId = null;
      if (id) {
        leadId = id;
      } else {
        leadId = localStorage.getItem("leadId");
      }
      apiClient
        .get(`/leads-managment/get-lead/${id}`)
        .then((res) => {
          this.singleLeadData = res.data.data;
          // console.log(this.singleLeadData, "test one lead");
        })
        .catch((err) => {
          console.error("Error fetching lead:", err);
        });
    },

    getAleadForEdit() {
      const id = localStorage.getItem("leadId");
      apiClient
        .get(`/leads-managment/get-lead/${id}`)
        .then((res) => {
          this.singleLeadData = res.data.data;
          console.log(this.singleLeadData);
        })
        .catch((err) => {
          console.error("Error fetching lead:", err);
        });
    },

    openCallDialog(id, item) {
      this.callDialog = true;
      this.call_id = id;

      this.data_call.call_for = item.firstName + " " + item.lastName;
      this.data_call.number = this.normalizeToPhoneObjects(
        item?.phones ?? item?.phoneNumber ?? ""
      );

      this.data_call.type = "Call Summary";
      this.data_call.phone = item?.phoneNumber ?? "";
    },
    phoneArrayFromDataCall(dc) {
      // dc.number ممكن تبقى [{phone:'...'}] أو ['...'] أو فاضية
      const list = Array.isArray(dc?.number) ? dc.number : [];

      const fromArray = list
        .map((n) =>
          typeof n === "object" ? n?.phone ?? n?.value ?? n?.number ?? "" : n
        )
        .map((v) => String(v || "").trim())
        .filter(Boolean);

      const fromSingle = dc?.phone ? [String(dc.phone).trim()] : [];

      // لو المستخدم كتب في الليست (multi) نستخدمها،
      // لو فاضية ن fallback للـ phone الفردي
      return fromArray.length ? fromArray : fromSingle;
    },

    async createCall(id) {
      try {
        const numbers = this.phoneArrayFromDataCall(this.data_call); // ← موحّد

        const formData = new FormData();
        formData.append("call_for", this.data_call.call_for || "");
        formData.append("status", this.data_call.status || "");
        formData.append("content", this.data_call.content || "");
        formData.append(
          "from",
          this.data_call.from
            ? this.formatDateForMySQL(this.data_call.from)
            : ""
        );
        formData.append("type", "Call Summary");

        // phones[0], phones[1], ... حتى لو رقم واحد
        numbers.forEach((p, i) => formData.append(`phones[${i}]`, p));

        const res = await apiClient.post(
          `/leads-managment/overview/${id}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        this.callDialog = false;
        this.genaralStore.showSnackbar(res.data.msg, "#237276");
        this.singleLeadData = [];
        this.getALead(id);
      } catch (err) {
        console.error("Error creating call:", err?.msg || err);
        this.genaralStore.showSnackbar(err?.msg || "Error", "error");
      }
    },
    // openMeetingDialog IN SingleLeadCom
    toPhoneObjects(input) {
      if (!input) return [];
      if (typeof input === "string") {
        try {
          input = JSON.parse(input);
        } catch {
          input = [input];
        }
      }
      const arr = Array.isArray(input) ? input : [input];
      return arr
        .map((v) => {
          if (typeof v === "string") return { phone: v.trim() };
          if (v && typeof v === "object") {
            const p =
              v.phone ?? v.value ?? v.number ?? v.mobile ?? v?.raw?.phone ?? "";
            return p ? { phone: String(p).trim() } : null;
          }
          return null;
        })
        .filter(Boolean);
    },

    openMeetingDialog(id, item) {
      this.meetingDialog = true;
      this.call_id = id;

      this.data_meeting.meeting_for = `${item.firstName || ""} ${
        item.lastName || ""
      }`.trim();

      const raw =
        Array.isArray(item?.phones) && item.phones.length
          ? item.phones
          : item?.phoneNumber
          ? [item.phoneNumber]
          : [];

      const numbers = this.toPhoneObjects(raw);
      this.store.data_meeting.number = numbers; // للـ UI (قائمة)
      this.store.data_meeting.phone =
        numbers[0]?.phone || item?.phoneNumber || ""; // fallback واحد

      this.data_meeting.type = "Meeting";
    },

    async createMeeting() {
      this.data_meeting.from = this.formatDateForMySQL(this.data_meeting.from);
      this.data_meeting.to = this.formatDateForMySQL(this.data_meeting.to);
      await apiClient
        .post(`/leads-managment/overview/${this.call_id}`, this.data_meeting)
        .then((res) => {
          this.meetingDialog = false;
          this.data_meeting = {};

          this.genaralStore.showSnackbar(res.data.msg, "#237276");
          this.singleLeadData = [];
          this.getALead();
        })
        .catch((err) => {
          console.error("Error creating meeting:", err.msg);
          this.genaralStore.showSnackbar(err.data.msg, "error");
        });
    },
    parseRelativeTime(timeString) {
      const now = new Date();
      if (timeString.includes("minute")) {
        const minutes = parseInt(timeString);
        now.setMinutes(now.getMinutes() - minutes);
      } else if (timeString.includes("hour")) {
        const hours = parseInt(timeString);
        now.setHours(now.getHours() - hours);
      } else if (timeString.includes("day")) {
        const days = parseInt(timeString);
        now.setDate(now.getDate() - days);
      }
      return now;
    },
    updateProgressStatus(id, val) {
      const index = this.leads.findIndex((item) => item.id === id);
      if (index !== -1) {
        this.leads[index].progress_status = val;
      }
    },

    openEditMeetingDialog(meeting) {
      const lead = meeting?.lead || {};
      const fromDate = meeting?.not_parsed_from
        ? new Date(meeting.not_parsed_from)
        : null;
      const toDate = meeting?.not_parsed_to
        ? new Date(meeting.not_parsed_to)
        : null;
      this.meeting_id = meeting.activity_id;
      this.edit_dialog = true;
      this.data_meeting = {
        meeting_for: `${lead?.first_name ?? ""} ${
          lead?.last_name ?? ""
        }`.trim(),
        number: lead?.phone ?? "",
        content: meeting?.content ?? "",
        from: fromDate,
        to: toDate,
        agent_id: Array.isArray(meeting?.agent_id)
          ? meeting.agent_id
          : [meeting?.agent_id].filter(Boolean),
        status: meeting?.status ?? "",
        type: "Meeting",
        meeting_place: meeting?.meeting_place ?? "",
        meeting_title: meeting?.meeting_title ?? "",
      };
      this.meetingDialog = true;
    },
    normalizeToPhoneObjects(input) {
      if (!input) return [];
      // لو داخل string JSON زي ["0123", {"phone":"0456"}] نفكّه
      if (typeof input === "string") {
        try {
          const parsed = JSON.parse(input);
          input = parsed;
        } catch (e) {
          // لو سترنج عادي (رقم واحد)
          input = [input];
        }
      }
      const arr = Array.isArray(input) ? input : [input];
      return arr
        .map((v) => {
          if (typeof v === "string") return { phone: v.trim() };
          if (v && typeof v === "object") {
            const p =
              v.phone ?? v.value ?? v.number ?? v.mobile ?? v?.raw?.phone ?? "";
            return p ? { phone: String(p).trim() } : null;
          }
          return null;
        })
        .filter(Boolean);
    },
    normalizeToPhoneStrings(input) {
      if (!input) return [];
      // فك JSON لو جالك سترنج
      if (typeof input === "string") {
        try {
          input = JSON.parse(input);
        } catch (e) {
          input = [input];
        }
      }
      const arr = Array.isArray(input) ? input : [input];
      return arr
        .map((v) => (typeof v === "string" ? v : v?.phone))
        .map((x) => (x == null ? "" : String(x).trim()))
        .filter(Boolean);
    },

    openEditCallDialog(call, leads_name) {
      const fullName = leads_name.first_name + " " + leads_name.last_name;

      this.edit_call = true;
      this.edit_dialog = true;

      const lead = call?.lead || {};
      const fromDate = call?.not_parsed_from
        ? new Date(call.not_parsed_from)
        : null;

      // اختَر phones غير فاضية وإلا خُد phone
      let rawPhones =
        Array.isArray(call?.number) && call.number.length > 0
          ? call.number
          : Array.isArray(this.singleLeadData?.phones) &&
            this.singleLeadData.phones.length > 0
          ? this.singleLeadData.phones
          : this.singleLeadData?.phone
          ? [this.singleLeadData.phone]
          : [];

      const numbers = this.normalizeToPhoneObjects(rawPhones);
      const firstPhone = numbers.length ? numbers[0]?.phone : lead?.phone ?? "";

      this.call_id = call.activity_id;

      this.data_call = {
        call_for: fullName.trim(),
        number: numbers, // للـ UI لو أكتر من رقم
        phone: firstPhone || "", // فال-باك للمدخل المفرد
        status: call?.status ?? "",
        content: call?.content ?? "",
        from: fromDate,
        type: "Call Summary",
      };

      this.callDialog = true;
    },

    formatDateTime(dateString) {
      if (!dateString) return null;
      const date = new Date(dateString);

      // رجع التاريخ بصيغة MySQL: YYYY-MM-DD HH:mm:ss
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    async editMeeting() {
      try {
        const payload = {
          ...this.data_meeting,
          // تأكد من تحويل Date → ISO أو форمات اللي الـ backend منتظره
          from: this.data_meeting.from
            ? this.formatDateTime(this.data_meeting.from)
            : null,
          to: this.data_meeting.to
            ? this.formatDateTime(this.data_meeting.to)
            : null,
          type: "Meeting",
        };

        const res = await apiClient.post(
          `/leads-managment/update-overview/${this.call_id}`,
          payload
        );

        await this.getAleadForEdit();
        this.meetingDialog = false;
        this.data_meeting = {};
        this.genaralStore.showSnackbar(res.data.msg, "#237276");
      } catch (err) {
        console.error("Error editing meeting:", err?.msg || err);
        this.genaralStore.showSnackbar(err?.data?.msg || "Error", "error");
      }
    },

    deleteActivity(overview_id, lead_id) {
      console.log("➡️ deleteActivity:", overview_id, lead_id);
      apiClient
        .post("/leads-managment/delete-overview", {
          overview_id,
          lead_id,
        })
        .then((res) => {
          this.getALead(lead_id);
          this.genaralStore.showSnackbar(res.data.msg, "#237276");
        })
        .catch((err) => {
          console.error("Error deleting activity:", err?.msg || err);
          this.genaralStore.showSnackbar(err?.data?.msg || "Error", "error");
        });
    },

    editLead() {
      // افتح وضع التعديل
      this.edite_card = true;
      // 1) لازم الـ date يكون Date object عشان الـ VueDatePicker
      if (
        this.singleLeadData?.lead_genration_time &&
        !(this.singleLeadData.lead_genration_time instanceof Date)
      ) {
        this.singleLeadData.lead_genration_time = new Date(
          this.singleLeadData.lead_genration_time
        );
      }
      // 2) عيّن leadSource كـ object من الليست بناءً على القيمة الحالية
      if (this.singleLeadData?.source) {
        const found = this.leadSources.find(
          (s) => s.value === this.singleLeadData.source
        );
        this.leadSource = found || null;
      } else {
        this.leadSource = null;
      }
      // 3) جهّز الـ selectedAgency لو عندك assigned_agents
      // ملاحظة: استدعي getAgencies() لو اللست لسه فاضية
      if (!this.arr_agency?.length) {
        this.getAgencies();
      }
      const currentAgentId =
        this.singleLeadData?.assigned_agents?.id ??
        this.singleLeadData?.agent_id ??
        null;
      if (currentAgentId) {
        const foundAgent = this.arr_agency.find((a) => a.id === currentAgentId);
        this.selectedAgency = foundAgent || null;
      } else {
        this.selectedAgency = null;
      }
    },
    async saveEditLead(id) {
      try {
        this.loading = true;
        const requiredFields = [
          "first_name",
          "last_name",
          "lead_genration_time",
        ];
        for (const field of requiredFields) {
          const v = this.singleLeadData?.[field];
          if (!v) {
            this.loading = false;
            this.genaralStore.showSnackbar(
              `You Have To Fill: ${field.replaceAll("_", " ")}`,
              "error"
            );
            return;
          }
        }
        const formData = new FormData();
        formData.append("first_name", this.singleLeadData.first_name?.trim());
        formData.append("last_name", this.singleLeadData.last_name?.trim());
        if (this.singleLeadData.email) {
          formData.append("emails[0]", this.singleLeadData.email.trim());
        }
        if (this.singleLeadData.phone) {
          formData.append("phone", this.singleLeadData.phone);
        }
        (this.singleLeadData.phones || []).forEach((p, i) => {
          const phone = (p?.phone || "").trim();
          const phone_name = (p?.phone_name || "").trim();
          const id = p?.id ?? null;

          if (!phone) return;

          formData.append(`phones[${i}][phone]`, phone);

          if (phone_name) {
            formData.append(`phones[${i}][phone_name]`, phone_name);
          }

          if (id !== null) {
            formData.append(`phones[${i}][id]`, String(id));
          }
        });

        formData.append(
          "source",
          this.leadSource?.value ?? this.singleLeadData.source ?? null
        );

        formData.append(
          "lead_genration_time",
          this.singleLeadData.lead_genration_time
            ? this.formatDateForMySQL(
                new Date(this.singleLeadData.lead_genration_time)
              )
            : null
        );

        formData.append("agent_id", this.selectedAgency?.id ?? null);
        formData.append("status", this.singleLeadData.status ?? null);
        formData.append("note", this.singleLeadData.note ?? null);
        formData.append("progress_status", this.progress_status ?? null);
        await apiClient.post(`/leads-managment/edit/lead/${id}`, formData);
        this.genaralStore.showSnackbar("Lead updated successfully", "#237276");
        this.edite_card = false;
        this.loading = false;
        await this.getALead(id);
      } catch (err) {
        console.error("Error editing lead:", err?.response?.data || err);
        this.loading = false;
        this.genaralStore.showSnackbar(
          err?.response?.data?.msg || "Update failed",
          "error"
        );
      }
    },

    formatDateFromInput(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },
  },
});
